import { useInfiniteQuery } from '@tanstack/react-query';
import type { AgentApiCandidateChatMessagesIndex } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

export default function useFetchCandidateChatMessages(candidateProfileId: number) {
  return useInfiniteQuery({
    queryKey: ['candidateChatMessages', candidateProfileId],
    queryFn: async ({ pageParam = 1 }) => {
      const data = await fetchJson<AgentApiCandidateChatMessagesIndex>(
        `/agent/api/candidate_profiles/${candidateProfileId}/candidate_chat_messages.json?page=${pageParam}`
      );
      return data;
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.is_last_page) {
        return undefined;
      }
      return allPages.length + 1;
    },
    initialPageParam: 1,
    refetchOnWindowFocus: true,
  });
}
